import "./CopyRightForm.scss";
import DownloadFormBtn from '../../../../components/Download Form Button/DownloadFormBtn';

const CopyRightForm = () => {

    return (
        <section className="copyRightFormMainContainer">
            <div style={{ display: "flex", alignItems: "center", width: "100%", margin: "auto 0" }}>
                <DownloadFormBtn btnName="Copyright Form" titleFontSize="clamp(1rem, 1.3vw, 1.2rem)"
        onClick={() => window.open("/copyrightform.pdf", "_blank")}
        />
            </div>
            <div>
                <h3>Submit Paper</h3>
                <p style={{fontFamily:"Gilroy-Medium"}}>Submit your papers to njsch@nicollege.com in the format prescribed.</p>
            </div>
        </section>
    )
}

export default CopyRightForm
